
export class WorkflowTemplate {
    id?;
    workflowStepId?;
    code?;
    serviceCode?;
    isGeneral?;
}
